export const PERSONAL_DATA_FETCH_INIT = 'PERSONAL_DATA_FETCH_INIT';
export const PERSONAL_DATA_FETCH_SUCCESS = 'PERSONAL_DATA_FETCH_SUCCESS';
export const PERSONAL_DATA_FETCH_ERROR = 'PERSONAL_DATA_FETCH_ERROR';

export const PERSONAL_DATA_POST_INIT = 'PERSONAL_DATA_POST_INIT';
export const PERSONAL_DATA_POST_SUCCESS = 'PERSONAL_DATA_POST_SUCCESS';
export const PERSONAL_DATA_POST_ERROR = 'PERSONAL_DATA_POST_ERROR';

export const PERSONAL_DATA_RESET = 'PERSONAL_DATA_RESET';
